import fetch from 'isomorphic-fetch';
import fs from 'fs';
import FormData from 'form-data';
import Busboy from 'busboy';
import { detect } from 'detect-browser';
import AWS from "aws-sdk";
import Config from '../server/config/';
const browser = detect();

const FilesTooling = {
  downloadFileServerSide: async (req, res, url, extension, token, postMode = false, body = null) => {
    try {
      let response;
      if(!postMode) {
        response = await fetch(url, {
          method: 'GET',
          headers: new Headers({
            Authorization: `Bearer ${token}`
          })
        });
      }
      else {
        response = await fetch(url, {
          method: "POST",
          headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json',
            Accept: 'application/json'
          }),
          body: JSON.stringify(body)
        });
      }
      const data = await response.body;
      const status = response.status;

      if(status == 200) {
        const num = Math.floor(Math.random() * 10000);
        const name = `./file-${num}-${Date.now()}.${extension}`;
        const file = data.pipe(fs.createWriteStream(name));

        file.on('finish', function() {
          res.status(status).download(file.path);
          setTimeout(function() {
            try {
              fs.unlinkSync(name);
            } catch (err) {}
          }, 1000);
        });

        return true;
      }
      else {
        return res.status(500).send({ message: 'Problema API' });
      }
    } catch (err) {
      console.log(err, 'No conectado');
      return res.status(500).send({ message: 'Problema API' });
    }
  },
  downloadFileClientSide: async (url, downloadName, params = null) => {    
    const response = await fetch(url + (params ? "/" + encodeURIComponent(JSON.stringify(params)): ""), {
      method: 'GET',
      'Content-Type': 'blob',
      headers: new Headers({
        Pragma: 'no-cache'
      })
    });
    const status = response.status;
    const blob = await response.blob();
    var a = document.createElement('a');
    if (browser.name == 'ie' && status == 200) {
      window.navigator.msSaveBlob(blob, downloadName);
    } else if (status == 200) {
      a.setAttribute('href', window.URL.createObjectURL(blob));
      a.setAttribute('target', '_blank');
      a.setAttribute('download', downloadName);
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    return {
      data: 'ok',
      status: status
    };
  },
  uploadMutipleFilesServerSide: async (req, res, url) => {
    const num = Math.floor(Math.random() * 10000);
    let namePreFix = `file-${num}-${Date.now()}-`;
    const busboy = new Busboy({ headers: req.headers });
    let remote_path = null;
    var counter = 0;
    var finished = false;

    const onFinishFunction = async function() {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${req.session.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }),
          body: JSON.stringify({
            remote_path: remote_path
          })
        });      
        const status = response.status;        
        if(status==204) {
          return res.status(200).send({});
        }
        const data = await response.json();
        return res.status(status).send(data);
      } catch (err) {
        console.log(err, 'No conectado');
        return res.status(500).send({ message: 'Problem API' });
      }
    };

    busboy.on('error', function(err) {
      console.error('Error while parsing the form: ', err);
      return res.status(500).send({ message: 'Problem API' });
    });

    busboy.on('file', (fieldname, file, filename, encoding, mime) => {
      counter++;
      if(!req.session.customer_id) {
        console.error('Error while parsing the form: ', err);
        return res.status(500).send({ message: 'Problem API' });
      }
      let name = namePreFix + filename;
      let remote_folder = "tenant_" + req.session.customer_id + "/temp/"
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: Config.awsBucketName,
          Key: remote_folder + name,
          Body: file
        }
      });
      var promise = upload.promise();
      promise.then(
        function(data) {
          remote_path = data.Key;
          counter--;
          if(counter == 0) {
            finished = true;
            onFinishFunction();
          }
        },
        function(err) {
          console.error('Error while parsing the form: ', err);
          return res.status(500).send({ message: 'Problem API' });
        }
      );
    });

    busboy.on('finish',function(){
      if(counter == 0 && finished == false) {
        onFinishFunction();
      }
    });

    req.pipe(busboy);
  },
  uploadMutipleFilesClientSide: async (url, files, params = null) => {
    var formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      formData.append('file'+i, files[i]);
    }
    let response = await fetch(url + (params ? "/" + encodeURIComponent(JSON.stringify(params)): ""), {
      body: formData,
      method: 'POST',
      headers: new Headers({ Pragma: 'no-cache' })
    });
    const status = response.status;
    const data = await response.json();
    return { data: data, status: status };
  },
};

export default FilesTooling;


// WEBPACK FOOTER //
// ./source/tooling/filesTooling.js